import { ShippingChargesHeader } from './shipping-charges-header.component';
import { ShippingChargesTableComponent } from './shipping-charges-table.component';
import { ShippingChargesTableRowComponent } from './shipping-charges-table-row.component';

export const components: any[] = [
  ShippingChargesHeader,
  ShippingChargesTableComponent,
  ShippingChargesTableRowComponent
];

export * from './shipping-charges-header.component';
export * from './shipping-charges-table.component';
export * from './shipping-charges-table-row.component';
